'use client';

import { useEffect, useState } from 'react';
import { useRouter, usePathname } from 'next/navigation';

export function useAuth(requireAuth = true) {
    const router = useRouter();
    const pathname = usePathname();
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('token');
            const user = localStorage.getItem('user');

            const authenticated = !!(token && user);
            setIsAuthenticated(authenticated);

            // If authentication is required and user is not authenticated
            if (requireAuth && !authenticated && pathname !== '/login') {
                router.push('/login');
            }

            // If user is authenticated but trying to access login page
            if (authenticated && pathname === '/login') {
                router.push('/');
            }

            setIsLoading(false);
        };

        checkAuth();
    }, [router, pathname, requireAuth]);

    return { isAuthenticated, isLoading };
}

export function getAuthUser() {
    if (typeof window === 'undefined') return null;

    const userStr = localStorage.getItem('user');
    if (!userStr) return null;

    try {
        return JSON.parse(userStr);
    } catch {
        return null;
    }
}

export function getAuthToken() {
    if (typeof window === 'undefined') return null;
    return localStorage.getItem('token');
}

export function isUserAuthenticated() {
    if (typeof window === 'undefined') return false;
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    return !!(token && user);
}
